import PropTypes from 'prop-types';
import { Box, Link } from '@qga/roo-ui/components';
import { ColumnItem, H2, ItemContent, ItemLabel } from '../primitives';
import { Column, Row } from '../../primitives';

const HotelDetails = ({
  hotelName,
  hotelAddress,
  hotelPhone,
  hotelEmail,
  roomType,
  bedGroupDescription,
  offerDescription,
  inclusions,
  specialRequests,
}) => (
  <Box as="article">
    <H2>Your hotel details</H2>
    <Row>
      <Column width={['50%', 'auto']}>
        <ColumnItem>
          <ItemLabel>Hotel</ItemLabel>
          <ItemContent>
            <strong>{hotelName}</strong>
          </ItemContent>
          <ItemContent>{hotelAddress}</ItemContent>
        </ColumnItem>
        {(hotelPhone || hotelEmail) && (
          <ColumnItem>
            <ItemLabel>Contact the hotel</ItemLabel>
            {hotelPhone && (
              <ItemContent>
                Phone:{' '}
                <Link href={`tel: ${hotelPhone}`} color="greys.charcoal">
                  {hotelPhone}
                </Link>
              </ItemContent>
            )}
            {hotelEmail && (
              <ItemContent>
                Email:{' '}
                <Link href={`mailto: ${hotelEmail}`} color="greys.charcoal">
                  {hotelEmail}
                </Link>
              </ItemContent>
            )}
          </ColumnItem>
        )}
      </Column>
      <Column width={['50%', 'auto']}>
        <ColumnItem>
          <ItemLabel>Room</ItemLabel>
          <ItemContent>1 x {roomType}</ItemContent>
          {bedGroupDescription ? <ItemContent>Bed type: {bedGroupDescription}</ItemContent> : null}
          {offerDescription ? <ItemContent mt={2}>{offerDescription}</ItemContent> : null}
          {inclusions ? <ItemContent>Inclusions: {inclusions}</ItemContent> : null}
          {specialRequests ? <ItemContent>Special requests: {specialRequests}</ItemContent> : null}
        </ColumnItem>
      </Column>
    </Row>
  </Box>
);

HotelDetails.propTypes = {
  hotelName: PropTypes.string.isRequired,
  hotelAddress: PropTypes.string.isRequired,
  hotelPhone: PropTypes.string,
  hotelEmail: PropTypes.string,
  roomType: PropTypes.string.isRequired,
  bedGroupDescription: PropTypes.string,
  offerDescription: PropTypes.string,
  inclusions: PropTypes.string,
  specialRequests: PropTypes.string,
};

export default HotelDetails;
